export default __webpack_public_path__ + "static/media/white_membershippass.1f4dfb6a.svg";